import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Comparison from './components/Comparison';
import WhySection from './components/WhySection';
import CategoryGrid from './components/CategoryGrid';
import SeoSection from './components/SeoSection';
import Testimonial from './components/Testimonial';
import FullCTA from './components/FullCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Kakobuy Finds",
            "url": "https://kakobuyfinds.lifestyle/",
            "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png",
            "description": "Kakobuy Spreadsheet - niezależny przewodnik po listach produktów, finds i poradach zakupowych. Znajduj najlepsze produkty szybciej.",
            "sameAs": ["https://kaspreadsheet.com"],
            "areaServed": {
              "@type": "Country",
              "name": "Poland"
            },
            "inLanguage": "pl"
          })
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Comparison />
        <WhySection />
        <CategoryGrid />
        <SeoSection />
        <Testimonial />
        <FullCTA />
      </main>
      <Footer />
    </>
  );
}